import React from "react";
import PublicPage from "./PublicPage";
import LegalTabs from "./LegalTabs";

export default function Security() {
    return (
        <PublicPage kicker="&gt; legal.security" title="Security" updated="July 2026" testid="page-security" tabs={<LegalTabs />}>
            <p>
                Security is not a feature at Vyaahar — it's a prerequisite. Books, ledgers, and bank data are the
                most sensitive things a business owns. Here is how we treat yours.
            </p>

            <div
                data-testid="security-at-a-glance"
                style={{
                    marginTop: 20,
                    padding: "12px 16px",
                    background: "rgba(166,138,86,0.08)",
                    border: "1px solid rgba(166,138,86,0.28)",
                    borderRadius: 4,
                    fontSize: 13.5,
                    fontFamily: "IBM Plex Mono, monospace",
                    color: "var(--vy-navy)",
                    letterSpacing: "0.02em",
                }}
            >
                <span style={{ color: "var(--vy-gold)", fontWeight: 600, marginRight: 8 }}>At a glance:</span>
                TLS 1.2+ &middot; AES-256 encryption at rest &middot; SOC 2 Type II — in progress
            </div>

            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Encryption</h2>
            <ul>
                <li>All traffic to Vyaahar is TLS 1.2+ end-to-end.</li>
                <li>Data at rest is encrypted with industry-standard AES-256.</li>
                <li>Passwords are hashed with bcrypt; we never see the plaintext.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Access controls</h2>
            <ul>
                <li>Role-based access within each organisation — owner, admin, accountant, viewer.</li>
                <li>All authenticated actions are audit-logged.</li>
                <li>Two-factor authentication is on the roadmap for all paid tiers.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Infrastructure</h2>
            <ul>
                <li>Hosted on vetted cloud providers with SOC 2 / ISO 27001 attestations.</li>
                <li>Databases are backed up daily with point-in-time recovery.</li>
                <li>Environments are isolated — no shared credentials between dev, staging, and production.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Compliance roadmap</h2>
            <p>
                We are honest about where we stand. SOC 2 Type II certification is currently in progress. We do not
                claim certifications we do not hold, and we'll update this page the moment our status changes.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Your data is never training data</h2>
            <p>
                We do not share your ledger, invoices, or bank data with any third-party model provider for
                training. The AI Copilot queries your books at run-time; we do not batch-export your data anywhere.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Responsible disclosure</h2>
            <p>
                Found a security issue? Please email
                {" "}<a href="mailto:hello@scitus.ai" style={{ color: "var(--vy-gold)" }}>hello@scitus.ai</a> with
                the subject line "Security report". We commit to acknowledging within two business days.
            </p>
        </PublicPage>
    );
}
